// Error during a call (route /callErrorHandler). The technical reason travels in the
// navigation state and the logs; the user always sees a generic, localised message.
import { useLocation } from 'react-router-dom'
import BrandLockup from '../components/BrandLockup'
import { t } from '../i18n'

const CallError = () => {
  const { state } = useLocation() as any

  if (state?.message) {
    console.error('Call error:', state.message)
  }

  const retry = () => {
    const scanUrl = sessionStorage.getItem('cf_scan_url')
    if (scanUrl) {
      window.location.hash = scanUrl.startsWith('#') ? scanUrl.slice(1) : scanUrl
    } else {
      window.location.reload()
    }
  }

  return (
    <div className="cf-page">
      <div className="cf-card">
        <BrandLockup />
        <div className="cf-icon">⚠️</div>
        <h1 className="cf-title">{t.callErrorTitle}</h1>
        <p className="cf-subtitle">{t.callErrorIntro}</p>
        <button className="cf-btn cf-btn-primary" onClick={retry}>
          {t.retry}
        </button>
      </div>
    </div>
  )
}

export default CallError
